import React, {
  useCallback,
  useMemo,
  useRef,
  useEffect,
  useState,
} from "react";
import { Navigate } from "react-router-dom";
import { Icon } from "../CreateIcons";
import CustomDropdown from "./CustomDropdown";
import {
  fetchserviceitems,
  fetchCuisineTypes,
  fetchCuisineMasters,
  fetchMealsType,
  fetchserviceitemssecond,
  fetchCuisineCategories,
} from "../../Apiservices/Auth/servers/fetchserviceitems";
import { tentdatafor_dialog } from "./Eventhardcodeddata";
import {
  getPriestToCartAPI,
  fetchTentCartAPI,
  fetchCateringCartAPI,
} from "../../Apiservices/Auth/cart/Addtocart_api";
import { Dropdown } from "primereact/dropdown";
import { setEventServiceData } from "../../store/eventServiceSlice";
import AddToCartButton from "../ServiceProvider/addtocartbutton";
import Showtentpackageforuser from "./tentpackage/Tentpackages"
import Cateringlistofprovider from "./cateringlistofprovider/Cateringlistofprovider";
import { AutoComplete } from "primereact/autocomplete";
import SendInvitation from "./SendInvitationbutton";
import debuglog from "../../util/helperutil";
import { CssBaseline, TextField, Autocomplete } from "@mui/material";
import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import "../eventComponent/EventTabs/EventTabs.css";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { fetchchatGptHowTo } from "../../Apiservices/Auth/servers/chatGptServer";
import {
  getPriestsListByLocation,
  getTentHouseListByLocationpost,
  getCateringListByLocation,
  getVenuesListByLocation,
  catering_includeditems,
  getCateringItemMasterList,
  gettentpackages,
} from "../../Apiservices/Auth/servers/fetchProviderData";
import { fetchReligionCaste } from "../../Apiservices/Auth/servers/fetchReligionCaste";
import { fetchLanguages } from "../../Apiservices/Auth/servers/fetchLanguages";
import config from "../../config";
import { capitalizeFirstLetter } from "../../util/typeCasting";
import { useDispatch, useSelector } from "react-redux";
import {
  addToCart,
  clearCart,
  clearPreistCart,
  clearTenthouseCart,
  clearCateringCart,
  removeFromCart,
  selectCartData,
} from "../../store/cartSlice";
import providerData from "../../ProviderServices.json";
//import ReligionAndCaste from "../../ReligionAndCaste.json";
import ButtonMailto from "../ButtonMailto";
import MyButton1 from "../CustomComponents/MyButton1";
import ProviderListingCard from "../ServiceProvider/ProviderListingCard";
import ProviderListWithPagination from "./ProviderListWithPagination";
import { Accordion, AccordionTab } from "primereact/accordion";
import { fetchStates } from "../../Apiservices/Auth/servers/fetchStates";
import Navbar from "../../redesign/components/Navbar";
import Footer from "../../redesign/components/Footer";
import ActionButton from "../ActionButton";
import Tenthouseaccordian from "./Tenthouseaccordian";
import CateringServiceforuser from "../newcateringuiforproviderlist/CateringServiceforuser";
import TaperedDivider from "../TaperedDivider";
import CatererOptionCard from "../CateringHelperComponents/CatererOptionCard";

import qiCateringLogo from "../../assets/images/qicatering_2.png"

import DiningTable from "../../assets/images/dining_table.png"
import StackSelectionComponent from "../TentHouseHelpercomponents/StackSelectionComponent";
import claender from "../../assets/images/calendar.png";
import locationicon from "../../assets/images/location.png";


function EventServices() {
  const cartData = useSelector((state) => state.cart.serviceList);
  const refreshKey = useSelector((state) => state.cart.refreshKey);
  const userDetails = useSelector((state) => state.user.userDetails);
  const [selectedSpaceId, setSelectedSpaceId] = useState(null);
  const dispatch = useDispatch();
  const [showMealError, setShowMealError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [providerListLoading, setProvideListLoading] = useState(false);
  const [castes, setCastes] = useState([]);
  //const [providerData, setProviderData] = useState([]);
  const [providerInfo, setProviderInfo] = useState([]);
  const [ReligionAndCaste, setReligionAndCaste] = useState({});
  const [casteKey, setCasteKey] = useState(0);
  const [states, setStates] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [Cateringdata, setCateringdata] = useState({});
  const [callquantityfotcateringdialog, setcallquantityfotcateringdialog] = useState(false)
  const [dialogOpen, setDialogOpen] = useState(false);
  const [cuisineTypes, setCuisineTypes] = useState([]);
  const [mealTypes, setMealTypes] = useState([]);
  const [tentpackages, settentpackages] = useState()
  const [autoOpenedDialog, setAutoOpenedDialog] = useState(false);
  // Static categories for catering item type hard codeed
  const categories = [
    { category_id: 1, category_name: "Vegetarian" },
    { category_id: 2, category_name: "Non-Veg" },
  ];

  const [selectedCuisineType, setSelectedCuisineType] = useState(null);
  const [selectedMeal, setSelectedMeal] = useState(null);

  const [selectedCategory, setSelectedCategory] = useState(null);

  const location = useLocation();

  const reduxData = useSelector((state) => state.eventService);
  const serviceDetails = reduxData.serviceDetails || location.state?.serviceDetails;
  const eventDetails = reduxData.eventDetails || location.state?.eventDetails;
  const eventimageid = eventDetails?.EventMasterDetails?.image?.id || null;

  console.log("serviceDetails", serviceDetails)
  console.log("eventDetails", eventDetails)

  const navigate = useNavigate();
  useEffect(() => {
    if (!serviceDetails || !eventDetails) {
      navigate("/dashboard");
    }
  }, [serviceDetails, eventDetails, navigate]);

  const [quantity, setQuantity] = useState(
    eventDetails?.rsvpCounts?.comingCount || 0
  );
  const [showCuisineError, setShowCuisineError] = useState(false);

  useEffect(() => {
    if (!serviceDetails || !eventDetails) {
      navigate("/dashboard", { replace: true });
    }
  }, [serviceDetails, eventDetails, navigate]);
  useEffect(() => {
    setQuantity(eventDetails?.rsvpCounts?.comingCount || 0);
  }, [serviceDetails]);
  // Sync quantity & event title when eventDetails changes
  useEffect(() => {
    if (eventDetails) {
      setQuantity(eventDetails?.rsvpCounts?.comingCount || 0);
      setEventStateTitle(eventDetails?.eventTitle || "");
    }
  }, [eventDetails]);

  const { id, serviceName } = serviceDetails;
  const activeIdRef = React.useRef(id);
  useEffect(() => {
    activeIdRef.current = id;
  }, [id]);
  console.log("testeveventDetails", eventDetails)
  const { eventTitle, locationLat, locationLong, eventId } = eventDetails;

  const [eventStateTitle, setEventStateTitle] = useState(
    eventTitle ? eventTitle : ""
  );
  const [AIdialogVisible, setAIdialogvisible] = useState(false);
  const [howTo, setHowTO] = useState("");
  const [context, setcontext] = useState("");

  const backtoEvents = () => {
    navigate("/dashboard");
  };

  const providerListStorageKey = config.providerListStorageKey;
  const providerList = localStorage.getItem(providerListStorageKey);

  if (providerList) {
    localStorage.removeItem(providerListStorageKey);
  }
  const [priestpackage, setpriestpackage] = useState([])
  const [serviceItems, setServiceItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [addedItems, setAddedItems] = useState([]);
  const [includeditems, setincludeditems] = useState([]);
  const [filteredItems_includeditems, setFilteredItems_includeditems] =
    useState([]);
  const [searchText, setSearchText] = useState([]);
  const [searchResults, setSearchResults] = useState([]);

  const handleCheckboxChange = (itemId, checked) => {
    setAddedItems((prev) => {
      const exists = prev.find((item) => item.id === itemId);
      let updated;
      if (exists) {
        updated = prev.map((item) =>
          item.id === itemId
            ? { ...item, checked, count: checked ? item.count || 1 : 0 }
            : item
        );
      } else {
        const itemToAdd = serviceItems.find((item) => item.id === itemId);
        updated = [...prev, { ...itemToAdd, checked, count: checked ? 1 : 0 }];
      }
      return updated.sort(
        (a, b) => (b.checked === true) - (a.checked === true)
      );
    });
  };

  const handleCountChange = (itemId, value) => {
    setAddedItems((prev) =>
      prev.map((item) =>
        item.id === itemId ? { ...item, count: value } : item
      )
    );
  };
  const handleSelectItem = (selected) => {
    if (!selected) return;

    setAddedItems((prev) => {
      const updated = prev.map((item) =>
        item.id === selected.id ? { ...item, checked: true, count: 1 } : item
      );

      // Move selected item to the top
      const selectedItem = updated.find((item) => item.id === selected.id);
      const rest = updated.filter((item) => item.id !== selected.id);

      return [selectedItem, ...rest];
    });
    setSelectedItem(null);
  };
  const [tenthousedatalist, settenthousedatalist] = useState([]);

  const fetchtentpackages = async () => {
    try {
      const response = await gettentpackages(eventDetails.eventId);
      console.log("raw response for package", response.data);
      
      // Safely extract packages depending on whether API returns an array directly or inside a data object
      const packages = Array.isArray(response.data?.data) 
        ? response.data.data 
        : (Array.isArray(response.data) ? response.data : []);
        
      console.log("extracted packages array:", packages);
      settentpackages(packages);

      // Check if no packages available and automatically open dialog
      if ((!packages || packages.length === 0) && !autoOpenedDialog && activeIdRef.current === 8) {
        setAutoOpenedDialog(true);
        await fetchServiceItemsfortenthouse();
        setDialogOpen(true);
      }
    } catch (error) {
      console.error("Error fetching tent packages:", error);
      if (!autoOpenedDialog && activeIdRef.current === 8) {
        setAutoOpenedDialog(true);
        await fetchServiceItemsfortenthouse();
        setDialogOpen(true);
      }
    }
  }

  const fetchServiceItemsfortenthouse = async () => {
    setLoading(true);
    try {
      const servicedata = await fetchserviceitems();
      const testdata = await fetchserviceitemssecond();

      settenthousedatalist(testdata.data);
      const serviceformattedData = servicedata.map((item) => ({
        id: item.id,
        service_name: item.service_name,
      }));
      setServiceItems(serviceformattedData);
      const initializedAddedItems = serviceformattedData.map((item) => ({
        ...item,
        checked: false,
        count: 0,
      }));
      setAddedItems(initializedAddedItems);
    } catch (error) {
      console.error("Failed to fetch events:", error);
    } finally {
      setLoading(false);
    }
  };

  const searchItems = (event) => {
    const query = event.query.trim().toLowerCase();
    if (query.length >= 3) {
      const filtered = serviceItems.filter((item) =>
        item.service_name.toLowerCase().includes(query)
      );
      setFilteredItems(filtered);
    } else {
      setFilteredItems([]); // clear dropdown
    }
  };
  const fetchReligionCasteData = useCallback(async () => {
    setLoading(true);
    try {
      const ReligionCastedata = await fetchReligionCaste();
      setReligionAndCaste(ReligionCastedata);
    } catch (error) {
      console.error("Failed to fetch events:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchLanguagesData = useCallback(async () => {
    setLoading(true);
    try {
      const LanguagesData = await fetchLanguages();
      setLanguages(LanguagesData);
    } catch (error) {
      console.error("Failed to fetch events:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchStatesData = useCallback(async () => {
    setLoading(true);
    try {
      const states = await fetchStates();
      setStates(states);
    } catch (error) {
      console.error("Failed to fetch states:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const [selectedTentHouseServiceIds, setSelectedTentHouseServiceIds] = useState([]);
  const [tentHouseFilterApplied, setTentHouseFilterApplied] = useState(false);
  const [CateringFilterApplied, setCateringFilterApplied] = useState(false);
  const [cancallcatering, setcancallcatering] = useState(false);
  const [quantityError, setQuantityError] = useState("");

  const handlecateringsave = () => {
    if (!quantity || quantity < 1) {
      setQuantityError("Please enter at least 1");
      return;
    }
    let hasError = false;

    if (!selectedMeal || Number(selectedMeal) === 0) {
      setShowMealError(true);
      hasError = true;
    } else {
      setShowMealError(false);
    }

    if (!selectedCuisineType || Number(selectedCuisineType) === 0) {
      setShowCuisineError(true);
      hasError = true;
    } else {
      setShowCuisineError(false);
    }

    if (hasError) {
      setcancallcatering(false);
      return false;
    }

    const payload = {
      categoryIds:
        selectedCategory && Number(selectedCategory) !== 0
          ? [Number(selectedCategory)]
          : [],
      mealIds:
        selectedMeal && Number(selectedMeal) !== 0
          ? [Number(selectedMeal)]
          : [],
      typeIds:
        selectedCuisineType && Number(selectedCuisineType) !== 0
          ? [Number(selectedCuisineType)]
          : [],
      cuisineMasterIds:
        selectedCuisineType && Number(selectedCuisineType) !== 0
          ? [Number(selectedCuisineType)]
          : [],
      cuisineIds:
        selectedCuisineType && Number(selectedCuisineType) !== 0
          ? [Number(selectedCuisineType)]
          : [],
      no_of_people: quantity,
      items: (searchText ?? []).map((item) => item.itemId),
    };

    console.log("Saved Payload:", payload);
    setCateringdata(payload);
    setShowMealError(false);
    setDialogOpen(false);
    setcancallcatering(true);
    return true;
  };

  const handlefilterserviceitems = (selectedItems) => {
    console.log("Received in parent:", selectedItems);
    if (!selectedItems) {
      setTentHouseFilterApplied(false);
      return;
    }
    const addeditemsfor = selectedItems.map((item) => item.id);
    const addeditemsforcount = selectedItems.map((item) => ({
      id: item.id,
      count: item.count,
    }));
    setSelectedTentHouseServiceIds(addeditemsfor);
    setTentHouseFilterApplied(true);
    setserviceitemsadded(addeditemsforcount);
    handleCloseitems();
  };

  const fetchPriestCartAndStore = async () => {
    if (id == 7) {
      try {
        const response = await getPriestToCartAPI();
        console.log("priest cart data", response)
        if (response.success && Array.isArray(response.result)) {
          response.result.forEach((eventItem) => {
            const eventID = eventItem.event_id;
            eventItem.priestItems.forEach((priestItem) => {
              if (
                priestItem?.priest?.id &&
                priestItem?.service?.id &&
                priestItem?.id !== undefined
              ) {
                const cartData = {
                  serviceType: "preist",
                  eventID,
                  providerID: priestItem.priest.id,
                  service_id: priestItem.service.id,
                  cart_id: priestItem.id,
                  price: priestItem.pricing.price,
                  discountprice: priestItem.pricing.discountPrice,
                  quantity: 1,
                  discountvalidupto: priestItem.pricing.discountValidUpto,
                  ...priestItem
                };
                dispatch(addToCart(cartData));
              } else {
                console.warn("Skipped invalid priestItem:", priestItem);
              }
            });
          });
        } else {
          console.warn(
            "Priest cart API did not return expected result:",
            response
          );
        }
      } catch (error) {
        console.error(
          "Failed to fetch or dispatch priest cart data:",
          error.message
        );
      }
    }
    if (id == 8) {
      try {
        const response = await fetchTentCartAPI();
        if (response.success && Array.isArray(response.data)) {
          response.data.forEach((eventItem) => {
            const eventID = eventItem.event_id;
            console.log("eventid", eventID);
            eventItem.tent_providers.forEach((tentItem) => {
              if (tentItem?.provider_id && eventID) {
                const cartData = {
                  serviceType: "tenthouse",
                  eventID: eventID,
                  providerID: tentItem.provider_id,
                  cart_id: null,
                };
                console.log("Adding to tenthouse cart:", cartData);
                dispatch(addToCart(cartData));
              } else {
                console.warn("Skipped invalid tentItem:", tentItem);
              }
            });
          });
        } else {
          console.warn(
            "Tent cart API did not return expected result:",
            response
          );
        }
      } catch (error) {
        console.error(
          "Failed to fetch or dispatch tent cart data:",
          error.message
        );
      }
    }
    if (id == 9) {
      try {
        const response = await fetchCateringCartAPI();
        console.log("catering", response);
        dispatch(clearPreistCart());
        response.data.data.forEach((item) => {
          const eventID = item.event_id;
          item.catering_providers.forEach((cateringitem) => {
            if (cateringitem.provider_id && eventID) {
              cateringitem.items.forEach((item) => {
                const cartdata = {
                  serviceType: "catering",
                  eventID,
                  providerID: cateringitem.provider_id,
                  mapping_id: item.item_id,
                };
                dispatch(addToCart(cartdata));
                console.log("added to cartslice", cartdata);
              });
            }
          });
        });
      } catch (error) {
        console.log("error wile fetching");
      }
    }
  };

  useEffect(() => {
    console.log("preist Cart changed!", cartData);
    fetchPriestCartAndStore();
  }, [refreshKey]);

  const [serviceitemsadded, setserviceitemsadded] = useState();
  const [cancallperist, setcancallperist] = useState(false);

  const fetchProviderList = useCallback(async () => {
    setProvideListLoading(true);
    setProviderInfo([]);

    try {
      let provider_data;

      switch (id) {
        case 7:
          setcancallperist(true);
          provider_data = await getPriestsListByLocation(
            locationLat,
            locationLong,
            eventId
          );
          break;

        case 8:
          if (tentHouseFilterApplied && selectedTentHouseServiceIds.length > 0) {
            provider_data = await getTentHouseListByLocationpost(
              locationLat,
              locationLong,
              eventId,
              selectedTentHouseServiceIds
            );
          } else {
            provider_data = { data: [] };
          }
          break;

        case 9:
          if (cancallcatering) {
            provider_data = await getCateringListByLocation(
              locationLat,
              locationLong,
              eventId,
              Cateringdata
            );
          } else {
            console.log("Failed to fetch data: Meal type not selected");
            provider_data = { data: [] };
          }
          break;

        case 10:
          const venueParams = {
            noOfPersons: quantity || 50,
          };
          const venueResult = await getVenuesListByLocation(
            locationLat,
            locationLong,
            eventId,
            venueParams
          );
          provider_data = venueResult;
          break;

        default:
          provider_data = { data: [] };
      }

      if (id === 7 || id === 10) {
        setProviderInfo(provider_data.data || []);
        setpriestpackage(provider_data.data || []);
      } else {
        setProviderInfo(provider_data.data || []);
      }

    } catch (error) {
      console.error("Failed to fetch events:", error);
      setProviderInfo([]);
    } finally {
      setProvideListLoading(false);
    }
  }, [id, tentHouseFilterApplied, cancallcatering, locationLat, locationLong, eventId, quantity, Cateringdata, selectedTentHouseServiceIds]);

  const handlePackageSelectforcatering = (packageData, quantityfromchild) => {
    console.log("Package selected:", packageData, includeditems, quantityfromchild);

    const allItemIds = [
      ...(packageData.included_items || []).map(item => item.itemId),
    ].filter(Boolean);

    console.log("📦 Extracted item IDs:", allItemIds);

    const cateringRequestData = {
      mealIds: [packageData.meal.meal_id],
      items: allItemIds,
      quantity: quantityfromchild || 10,
      typeIds: selectedCuisineType ? [Number(selectedCuisineType)] : [],
      cuisineMasterIds: selectedCuisineType ? [Number(selectedCuisineType)] : [],
      cuisineIds: selectedCuisineType ? [Number(selectedCuisineType)] : [],
    };

    console.log("🚀 Sending to backend:", cateringRequestData);

    setCateringdata(cateringRequestData);
    setQuantity(quantityfromchild)
    setDialogOpen(false);
    setcancallcatering(true);
  };

  const handleQuantityConfirm = () => {
    setcancallcatering(true);
    setcallquantityfotcateringdialog(true)
  }

  const handleCloseforcatering = () => {
    navigate('/dashboard');
  };

  const Getincludeditems = async () => {
    try {
      const included_items = await getCateringItemMasterList({
        exclude_side_items: true,
      });
      const normalizeitem = (included_items ?? [])
        .flatMap(category => category.items || [])
        .filter(item => item && item.id && item.itemName)
        .map(item => ({
          itemId: item.id,
          includedItemsString: item.itemName,
        }));
      setincludeditems(normalizeitem ?? []);
      const normalized = (included_items ?? []).filter((item) => (item.is_side_item === false)).map((item) => ({
        itemId: item.id,
        includedItemsString: item.itemName,
      }));
      setFilteredItems_includeditems(normalized);
      console.log("Entered", included_items);
    } catch (error) {
      console.error("got error", error);
    }
  };

  useEffect(() => {
    if (
      id === 7 ||
      (id === 8 &&
        tentHouseFilterApplied &&
        selectedTentHouseServiceIds.length > 0) ||
      (id === 9 && cancallcatering) ||
      id === 10
    ) {
      fetchProviderList();
      fetchPriestCartAndStore();
    }
  }, [
    id,
    tentHouseFilterApplied,
    selectedTentHouseServiceIds,
    cancallcatering,
    fetchProviderList,
  ]);

  useEffect(() => {
    if (serviceDetails) {
      setLoading(true);
      fetchProviderList();
      if (serviceDetails.id === 8) {
        fetchtentpackages();
      }
    }
  }, [location.state]);

  useEffect(() => {
    setDialogOpen(false);
    if (id !== 8) {
      setAutoOpenedDialog(false);
    }
  }, [id]);

  useEffect(() => {
    if (ReligionAndCaste?.religion) {
      const defaultReligion = ReligionAndCaste.religion.find(
        (religion) => religion.name === "Hindu"
      );
      if (defaultReligion) {
        setCastes(defaultReligion.castes);
      }
    }
  }, [ReligionAndCaste]);

  useEffect(() => {
    if (id === 8 && tentHouseFilterApplied) {
      console.log("Use Effect 1");
      fetchProviderList();
    }
  }, [id, fetchProviderList, tentHouseFilterApplied]);

  useEffect(() => {
    console.log("Use Effect 2");
    setProviderInfo([]);
    setcancallcatering(false);
    setSelectedTentHouseServiceIds([]);
    setTentHouseFilterApplied(false);
  }, [id]);

  useEffect(() => {
    if (id === 9) {
      const getCuisines = async () => {
        try {
          const selectedMealId = Cateringdata?.mealIds && Cateringdata.mealIds.length > 0
            ? Cateringdata.mealIds[0]
            : null;
          
          const res = await fetchCuisineMasters(selectedMealId);
          const cuisinesList = Array.isArray(res) ? res : (res?.data || []);
          if (Array.isArray(cuisinesList)) {
            const mappedCuisines = cuisinesList.map(cuisine => ({
              id: Number(cuisine?.id ?? cuisine?.type_id ?? cuisine?.ID ?? 0),
              name: String(cuisine?.name ?? cuisine?.type_name ?? cuisine?.label ?? "")
            })).filter(c => c.id !== 0);
            
            setCuisineTypes(mappedCuisines);
          }
        } catch (err) {
          console.error("Error fetching cuisine masters:", err);
        }
      };
      getCuisines();
    }
  }, [id, Cateringdata?.mealIds]);

  useEffect(() => {
    if (id === 7) {
      fetchProviderList();
    }
  }, [id]);

  useEffect(() => {
    console.log("Use Effect 3");
    fetchReligionCasteData();
    fetchStatesData();
    fetchLanguagesData();
    setProviderInfo([]);
    id !== 1 && fetchProviderList();
  }, [id]);

  useEffect(() => {
    console.log("Use Effect 4");
    id === 1 && howTo === "" && setAIdialogvisible(true);
    setLoading(false);
  }, [id]);

  const handleSearch = (e) => {
    const query = e.query.toLowerCase();
    console.log("filteredItems_includeditems", filteredItems_includeditems);
    const filtered = filteredItems_includeditems.filter((item) =>
      item.includedItemsString.toLowerCase().includes(query)
    );
    setSearchResults(filtered);
  };

  const [selectedService, setSelectedService] = useState(null);
  const [showInvitation, setShowInvitation] = useState(false);

  const handlecloseinvitation = (status) => {
    console.log("Dialog closed with status:", status);
    setShowInvitation(false);
  };

  const handleEventService = (service) => {
    const info = {
      serviceDetails: service,
      eventDetails:
        eventDetails && Object.keys(eventDetails).length > 0
          ? eventDetails
          : {},
    };
    dispatch(setEventServiceData(info));
    console.log("service", service);
    if (service.id === 2) {
      console.log("eventdetails", eventDetails, service);
      setSelectedService(service);
      setShowInvitation(true);
    } else {
      console.log("Info", info);
      navigate("/providers", { state: info });
    }
    window.scrollTo({ top: 0 });
  };

  function removeBlankAttributes(obj) {
    const result = {};
    for (const key in obj) {
      if (obj[key] !== "" && obj[key] !== undefined) {
        result[key] = obj[key];
      }
    }
    return result;
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      Religion: "Hindu",
      Caste: "",
      SubCaste: "",
      Language: "Telugu",
      Location: "Telangana",
      event: eventStateTitle,
      Gothram: localStorage.getItem('temp_gothram') || "",
    },
    onSubmit: async (values, { resetForm }) => {
      const altered = removeBlankAttributes(values);
      const question = `
You are a cultural event expert for Indian rituals. Based on the event and region provided, generate a structured JSON response for planning and understanding the event.

Inputs:
- Event Name: ${altered?.event}
- Region: ${altered?.Location}
- Religion: ${altered?.Religion}
- Caste: ${altered?.Caste}
- Subcaste: ${altered?.SubCaste}
- Language: ${altered?.Language}
- Gothram :${altered?.Gothram}

Instructions:
- Respond in valid JSON only.
- All content must be culturally specific **and directly relevant to the provided event** (e.g., "Ganesh Chaturthi", "Upanayanam", "Shraddha", etc.).
- Avoid generic or placeholder responses. Tailor every field to the cultural and ritual requirements of the input.
- Use the fixed 7 top-level keys **exactly as listed below**.
- Do not use any alphabetical or numerical prefixes like "a)", "Step 1:", etc.
- Each subkey must contain a culturally appropriate label and meaningful value.

✅ If any subkey clearly implies an action (like sending invitations or booking services), return it as a nested object in this format:

"SubkeyName": {
  "value": "<Descriptive content here>",
  "_action": "<one of the supported actions>"
}

Supported \`_action\` values:
- "send_invitation_button"
- "book_priest_button"
- "book_tent_button"
- "book_catering_button"

Only include \`_action\` if clearly relevant. If not, return only the plain string.

---

JSON Output Format:

{
  "Why is this event performed${altered?.Religion ? " in the " + altered.Religion + " tradition" : ""
        }${altered?.Location ? " in " + altered.Location : ""
        }?": "<2–3 sentence explanation that reflects why ${altered?.event
        } is important in ${altered?.Location}>",

  "Pre-Event Planning Checklist": {
      "Selecting an Auspicious Date": "<based on Panchangam or local custom${altered?.event ? ` for ${altered.event}` : ""
        }>",
  "Finalizing the Venue": "<e.g., temple for Ganesh Puja, home for Annaprashan, hall for Upanayanam>",
    "Booking Service Providers": {
     "value": "<e.g., a priest${altered?.Language ? ` who speaks ${altered.Language}` : ""
        } and understands related rituals is preferred>",
       "_action": "book_priest_button"
    },
    "Preparing Guest List and Sending Invitations": {
       "value": "<personalized invitations${altered?.Language ? ` in ${altered.Language}` : ""
        } sent to family and community members>",
     "_action": "send_invitation_button"
    },
    "Arranging Mandap and Setup": {
    "value": "<includes stage, sacred fire, mats, lights as per ${altered?.event || "ritual"
        }>",
        "_action": "book_tent_button"
    },
    "Managing Travel and Stay": "<if guests are arriving from distant cities>"
  },

  "Materials and Supplies Required": {
    "Pooja and Decoration Items": "<items like flowers, coconuts, lamps, sacred cloth for ${altered?.event || "the ceremony"
        }>",
    "Consumables for Guests and Rituals": "<Modak, Payasam, or other offerings depending on the event>",
    "Special Event Items": "<items like Upanayanam thread, Shraddha Pinda items, etc.>"
  },

  "Recommended Attire for the Event": {
    "Hosts and Key Participants": "<dhoti and angavastram for boys in Upanayanam, white clothing for Shraddha>",
    "Guests": "<regional traditional attire depending on the event>",
    "Accessories and Add-ons": "<garlands, sacred threads, betel leaves, etc.>"
  },

  "Step-by-Step Event Flow": [
    "<Welcoming of guests>",
     "<Sankalpam and initial prayers${altered?.Gothram ? ` including family Gothram (${altered.Gothram})` : ""
        }>",
    "<Main ritual of ${altered?.event || "the ceremony"
        } begins with guidance from the priest>",
 
    "<Offering blessings to elders/deities>",
    "<Distribution of prasadam or food>",
    "<Concluding prayers or Aarti>"
  ],

  "Food and Beverage Arrangements": {
    "Type of Meal": {
      "value": "<e.g., full vegetarian Andhra lunch on banana leaves>",
      "_action": "book_catering_button"
    },
    "Cuisine Style": "<based on region and caste — like Telugu Brahmin-style>",
    "Prasadam or Special Dishes": "<Modak for Ganesh, Kheer for Annaprashan, etc.>",
    "Water and Beverage Setup": "<bottled water stations if event is outdoors>"
  },

  "Post-Event Activities": {
    "Return Gifts and Gratitude Messages": "<kumkum box, blouse piece, or silver coin>",
    "Cleanup of Venue and Ritual Space": "<done by family or hired helpers>",
    "Offerings and Donations": "<Dakshina to priest, charity donations if relevant>",
    "Follow-Up Rituals or Visits": "<like going to a nearby temple next day>"
  }
}

Rules:
- Respond only with JSON. No markdown, bullets, or explanation.
- Each field must be **specific to the inputs** and feel authentically rooted in Indian cultural traditions.
- Use nested JSON only where actions are implied. Otherwise, return plain string values.
`;

      try {
        setLoading(true);
        setAIdialogvisible(false);
        const apiResponse = await fetchchatGptHowTo({
          question: question,
        });
        if (eventDetails.eventMasterDetails?.is_priest_required) {
          setcontext(
            `Just as Grandma used to say, here are the essential steps followed for ${values.event}:`
          );
        }
        setHowTO(JSON.parse(apiResponse["answer"]));
        const parsedData = JSON.parse(apiResponse["answer"]);
      } catch (error) {
        console.error("Failed to services:", error);
      } finally {
        setLoading(false);
        resetForm();
      }
    },
  });

  debuglog({
    eventstate: eventStateTitle ? eventStateTitle : "no event state",
  });
  debuglog({ eventdetails: EventServices });
  debuglog({ servicedetails: serviceDetails });

  const textFieldStyles = {
    backgroundColor: "#ffffff",
    width: "100%",
    borderRadius: "4px",
    marginBottom: "0",
  };

  const setCasteByReligion = (value) => {
    if (!ReligionAndCaste?.religion) return;
    const result = ReligionAndCaste.religion.find((obj) => obj.name === value);
    setCastes(result?.castes || []);
  };

  const handleReligionFieldChange = (field, value) => {
    formik.setValues({
      ...formik.values,
      Religion: value.name,
      Caste: "",
      SubCaste: "",
    });

    const result = ReligionAndCaste.religion.find(
      (obj) => obj.name === value.name
    );
    setCastes(result?.castes || []);
    setCasteKey((prev) => prev + 1);
  };

  const handleCasteFieldChange = (field, value) => {
    formik.setFieldValue(field, value.name);
  };

  const handleFieldChange = (field) => (event) => {
    const value = event.target.value;
    formik.setFieldValue(field, value);
  };

  const handleAIenabledService = () => {
    setAIdialogvisible(true);
  };

  const handleCloseitems = () => {
    setDialogOpen(false);
    if (id === 9) {
      setShowMealError(false);
    }
  };

  const handleOpen = async () => {
    if (id == 8) {
      try {
        await fetchServiceItemsfortenthouse();
        setDialogOpen(true);
      } catch (e) {
        console.log("got error", e);
      }
    }
    if (id === 9) {
      setDialogOpen(true);
      setcancallcatering(false);
      let fetchedCuisineTypes = [];
      let fetchedMealTypes = [];
      try {
        const selectedMealId = Cateringdata?.mealIds && Cateringdata.mealIds.length > 0
          ? Cateringdata.mealIds[0]
          : null;
        const rawCuisines = await fetchCuisineMasters(selectedMealId);
        const cuisinesList = Array.isArray(rawCuisines) ? rawCuisines : (rawCuisines?.data || []);
        if (Array.isArray(cuisinesList)) {
          fetchedCuisineTypes = cuisinesList.map(cuisine => ({
            id: Number(cuisine?.id ?? cuisine?.type_id ?? cuisine?.ID ?? 0),
            name: String(cuisine?.name ?? cuisine?.type_name ?? cuisine?.label ?? "")
          })).filter(c => c.id !== 0);
        }
        fetchedMealTypes = await fetchMealsType();
        Getincludeditems();
        setCuisineTypes(fetchedCuisineTypes);
        setMealTypes(fetchedMealTypes);
        if (!selectedCuisineType && fetchedCuisineTypes.length > 0) {
          setSelectedCuisineType(fetchedCuisineTypes[0].id);
        }
        if (!selectedCategory && categories.length > 0) {
          setSelectedCategory(categories[0].category_id);
        }
        if (!selectedMeal && fetchedMealTypes.length > 0) {
          const firstMeal = fetchedMealTypes[0];
          setSelectedMeal(firstMeal.meal_id);
          setShowMealError(false);
        }
      } catch (e) {
        console.log("erroe occure while fetchnig catering items", e);
      }
    }
  };

  const [selectedProviderId, setSelectedProviderId] = useState([]);
  const [comparemenubutton, setcomparemenubutton] = useState(false);

  const handlecheckboxcompare = (item) => {
    setSelectedProviderId((prev) => {
      const alreadySelected = prev.find((p) => p.id === item.id);
      if (alreadySelected) {
        return prev.filter((p) => p.id !== item.id);
      } else {
        return [...prev, item];
      }
    });
  };

  const renderProviderListById = (item, id) => {
    const fullName = [item.firstName, item.lastName].filter(Boolean).join(" ");

    if (id === 7 && cancallperist) {
      return (
        <ProviderListingCard
          serviceId="7"
          providerid={item.id}
          appointmentProviderId={item.serviceProviderId || item.provider?.id}
          event={eventDetails}
          key={`${id}-${item.id}`}
          latitude={item.latitude}
          longitude={item.longitude}
          name={fullName}
          address={item.formattedAddress}
          distance={item.distanceInMeter}
          mobile={item.mobile}
          email={item.email}
          price={item.price}
          discount={item.discountPrice}
          validUpto={item.discountValidUpto}
        />
      );
    } else if (
      id === 8 &&
      tentHouseFilterApplied &&
      selectedTentHouseServiceIds.length > 0
    ) {
      console.log("got to tenthouse");
      console.log({ itemrental: item })
      console.log("serviceitemsadded", serviceitemsadded)
      return (
        <ProviderListingCard
          serviceId="8"
          quantity={serviceitemsadded}
          event={eventDetails}
          services={item.services}
          providerid={item.providerId}
          key={`${id}-${item.id}`}
          latitude={item.latitude}
          longitude={item.longitude}
          name={item.name}
          address={item.formattedAddress}
          distance={item.distanceInMeter}
          mobile={item.mobile}
          email={item.emailId}
          price={item.price}
          discount={item.discountPrice}
        />
      );
    } else if (id === 9 && cancallcatering) {
      console.log({ catering: item })
      const selectedIds = (searchText ?? []).map((item) => item.itemId);
      const sortedServices = [...item.items].sort((a, b) => {
        const aMatches =
          a.includedItems?.filter((i) => selectedIds.includes(i.itemId))
            .length || 0;
        const bMatches =
          b.includedItems?.filter((i) => selectedIds.includes(i.itemId))
            .length || 0;
        return bMatches - aMatches;
      });
      console.log("sortedServices", sortedServices);
      console.log({ itemrental: item })
      return (
        <div key={item.id}>
          {sortedServices.map((service, idx) => (
            <ProviderListingCard
              key={`${item.id}-${idx}`}
              serviceId="9"
              services={service}
              quantity={quantity}
              providerid={item.id}
          appointmentProviderId={item.serviceProviderId || item.provider?.id}
              event={eventDetails}
              latitude={item.latitude}
              longitude={item.longitude}
              name={item.name}
              address={item.formattedAddress}
              distance={item.distanceInMeter}
              mobile={item.mobile}
              email={item.email}
              price={item.price}
              discount={item.discountPrice}
            />
          ))}
        </div>
      );
    } else if (id === 10) {
      return (
        <ProviderListingCard
          serviceId="10"
          providerid={item.id}
          appointmentProviderId={item.serviceProviderId || item.provider?.id}
          event={eventDetails}
          key={`${id}-${item.id}`}
          latitude={item.latitude}
          longitude={item.longitude}
          name={item.name}
          address={item.formattedAddress}
          distance={item.distanceInMeter}
          mobile={item.mobile}
          email={item.email}
          price={item.price}
          discount={item.discountPrice}
          validUpto={item.discountValidUpto}
          renderItem={(item) => (
            <ProviderListingCard
              serviceId="10"
              providerid={item.id}
          appointmentProviderId={item.serviceProviderId || item.provider?.id}
              event={eventDetails}
              key={`10-${item.id}`}
              latitude={item.latitude}
              longitude={item.longitude}
              name={item.name}
              address={item.formattedAddress}
              distance={item.distanceInMeter}
              mobile={item.mobile}
              email={item.email}
              price={item.price}
              discount={item.discountPrice}
              validUpto={item.discountValidUpto}
              rating={item.rating || 4.5}
              providerFirstName={item.provider?.firstName}
              providerLastName={item.provider?.lastName}
              shortAddress={item.shortAddress || item.formattedAddress}
              distanceInMeter={item.distanceInMeter}
              primaryImage={item.primaryImage}
              rules={item.rules || []}
              sections={item.spaces || []}
              expectedGuestCount={quantity}
              selectedSpaceId={selectedSpaceId}
              eventStartDate={eventDetails?.Date}
              eventEndDate={eventDetails?.endDate}
              rsvpGuestCount={eventDetails?.rsvpCounts?.comingCount}
              onSpaceSelected={setSelectedSpaceId}
              onBookNow={(spaceId) => {
                navigate(`/venue-booking/${item.id}?eventId=${eventDetails.id}&spaceId=${spaceId}`, {
                  state: {
                    venueId: null,
                    eventDetails: eventDetails,
                  }
                });
              }}
            />
          )}
        />
      );
    }
    return null;
  };

  const [showNote, setShowNote] = useState(false);

  const actionToTypeMap = {
    book_priest_button: "Priest",
    book_tent_button: "Rentals",
    book_catering_button: "Catering",
    send_invitation_button: "Invite",
    ai_enabled_button: "AI enabled",
  };

  const selectedlengthwithcount = serviceName ? serviceName.replace("{Count}", providerInfo.length) : "No service selected";

  const renderSection = (sectionData, providerData) => {
    console.log("In Render Action Service, servicetype is", providerData);

    if (typeof sectionData === "string") {
      console.log("sectionData _string", sectionData);
      return (
        <li>
          <span>{sectionData}</span>
        </li>
      );
    }

    if (Array.isArray(sectionData)) {
      console.log("sectionData _array", sectionData);
      return sectionData.map((item, index) => (
        <li key={`item-${index}`}>
          <span>{item}</span>
        </li>
      ));
    }
    return Object.keys(sectionData).map((key, i) => {
      console.log("sectionData _object", sectionData);
      const sectuionDataValue = sectionData[key];
      if (typeof sectuionDataValue === "object") {
        const { value, _action } = sectuionDataValue;
        if (value && _action) {
          console.log("Vaue and Sction is True");
          const serviceType = actionToTypeMap[_action];
          const service = providerData.find((s) => s.type === serviceType);
          return (
            <li key={key + i}>
              <span>{value}</span>
              {service && (
                <ActionButton
                  _action={_action}
                  showInvitationDialog={setShowInvitation}
                  service={service}
                  handleEventServiceClick={handleEventService}
                />
              )}
            </li>
          );
        }
        return (
          <li key={key}>
            {key}
            <ol style={{ listStyle: "none" }}>
              {Object.keys(sectuionDataValue).map((nestedKey, j) => {
                console.log("Nested key", nestedKey);
                return (
                  <li key={nestedKey + i + j}>
                    - <span>{sectuionDataValue[nestedKey]}</span>
                  </li>
                );
              })}
            </ol>
          </li>
        );
      }
      return (
        <li key={key}>
          <span>{sectuionDataValue}</span>
        </li>
      );
    });
  };

  const [selection, setSelection] = useState({
    veg: false,
    nonveg: false,
  });

  const toggleSelection = (type) => {
    setSelection((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  return (
    <div style={{ width: "100%" }}>
      <CssBaseline />
      <Navbar />
      <div className={`eventservice-main-container ${id === 7 ? "priest-page-container" : ""}`}>
        {/* s */}
        <div>
          <div>
            <div className="header-button">
              <button className="back_to_dashboard_in_provider" onClick={backtoEvents}>
                <i className="pi pi-arrow-left"></i>
                Back to Dashboard
              </button>
            </div>

            <div className="event-card-2">
              <div className="event-date-box">
                {eventimageid ? (
                  <div>
                    <img src={`${config.API_BASE_URL}/gallery/download/${eventimageid}`}
                      className="eventimages_display" alt="event" />
                  </div>
                ) : (
                  <div className="calendar-display">
                    <div className="calendar-month">
                      {new Date(eventDetails.Date).toLocaleString("default", {
                        month: "short",
                        timeZone: "UTC",
                      })}
                    </div>
                    <div className="calendar-day">
                      {new Date(eventDetails.Date).getDate()}
                    </div>
                  </div>
                )}
              </div>

              <div className="event-content">
                <div className="event-header">
                  <h3 className="event-title">
                    {eventDetails.eventTitle || "Untitled Event"}
                  </h3>
                  {eventDetails.cancel === true && (
                    <>
                      <div className="Cancled-Box">
                        <span className="cancled-text">Cancelled</span>
                      </div>
                    </>
                  )}
                </div>

                <div className="event-meta">
                  <div className="event-datetime">
                    <span className="meta-icon">
                      <img src={claender} alt="calendar" style={{ width: "16px", height: "16px" }} />
                    </span>
                    {new Date(eventDetails.Date).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      timeZone: "UTC",
                    })} {" "}
                    {new Date(eventDetails.Date).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                      timeZone: "UTC",
                    })}
                  </div>

                  <div className="event-location">
                    <span className="meta-icon">
                      <img src={locationicon} alt="location" style={{ width: "18px", height: "18px" }} />
                    </span>
                    {eventDetails.Location || "Location not specified add location"}
                  </div>
                </div>
              </div>
            </div>

            <div className="event-form-inner">
              <div className="event-form-body-container">
                <div className="event-form-body-container-inner">
                  {id !== 0 && (
                    <div className="event-service-container-list sidebar">
                      <div className="container-sidebar-inner">
                        {providerData.length > 0 &&
                          providerData
                            .filter((item) => {
                              if (item.id === id) return false;
                              if (
                                item.id === 7 &&
                                eventDetails.eventMasterDetails?.is_priest_required === false
                              )
                                return false;
                              return true;
                            })
                            .map((item) => (
                              <div
                                key={item.id}
                                className={`event-service-button-services ${item.id === id ? "isactive" : ""}`}
                                onClick={() => handleEventService(item)}
                              >
                                <div className="services-function">
                                  <Icon id={item.id} size={20} className="icon-default-color" />
                                  <div className="">
                                    <span>
                                      {item.serviceCardName}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))}
                        {showInvitation && (
                          <SendInvitation
                            event={eventDetails}
                            onClose={handlecloseinvitation}
                          />
                        )}
                      </div>
                    </div>
                  )}

                  <Dialog
                    header="compare menu"
                    visible={comparemenubutton}
                    position="center"
                    onHide={() => setcomparemenubutton(false)}
                  >
                    <>
                      <h1>"hello</h1>
                    </>
                  </Dialog>

                  <Dialog
                    visible={callquantityfotcateringdialog}
                    onHide={() => setcallquantityfotcateringdialog(false)}
                    header={"please choose the quantity"}
                    footer={
                      <div>
                        <button
                          className="custom-button save-button"
                          onClick={handleQuantityConfirm} disabled={!quantity || quantity <= 0}>
                          Confirm
                        </button>
                      </div>
                    }
                  >
                    <div className="input_dialog">
                      <input
                        className="quantity-input"
                        value={quantity || 0}
                        onChange={(e) => setQuantity(parseInt(e.target.value) || 0)}
                        placeholder="please enter quantity"
                        min="1"
                      />
                    </div>
                  </Dialog>

                  <Dialog
                    header={id === 9 ? "" : "Select from the items below"}
                    visible={dialogOpen}
                    position="center"
                    contentStyle={{
                      maxHeight: "70vh",
                      overflowY: "auto",
                    }}
                    headerStyle={id === 9 ? { padding: "0px" } : {}}
                    className={`dialog-box-provider ${id === 9 ? "narrow-width" : "default-width"}`}
                    onHide={handleCloseitems}
                    modal
                  >
                    {id === 8 && (
                      <>
                        <Tenthouseaccordian
                          serviceData={tenthousedatalist}
                          onNext={handlefilterserviceitems}
                        />
                      </>
                    )}
                    {id === 9 && (
                      <>
                        <CateringServiceforuser 
                          onNext={handlePackageSelectforcatering} 
                          onClose={handleCloseforcatering} 
                          quantityformparent={quantity} 
                          selectedCuisineType={selectedCuisineType}
                          selectedMeal={selectedMeal}
                        />
                      </>
                    )}
                  </Dialog>

                  {id === 1 ? (
                    <div className="event-providers">
                      {loading ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "200px",
                            width: "100%",
                            marginTop: "40px",
                          }}
                        >
                          <h3 style={{ margin: 0 }}>
                            <i
                              className="pi pi-spin pi-spinner-dotted"
                              style={{ fontSize: "2rem", color: "#0cc0df" }}
                            ></i>
                          </h3>
                        </div>
                      ) : (
                        <div
                          className={`event-service alter no-data ${howTo && "alignleft"}`}
                        >
                          {howTo ? (
                            <>
                              <p className="eventservice-body-header">
                                {context}
                              </p>
                              <div>
                                <Accordion
                                  activeIndex={null}
                                  className="Accordiandata"
                                >
                                  {Object.keys(howTo).map((sectionKey) => {
                                    console.log("Section Key ", sectionKey);
                                    return (
                                      <AccordionTab
                                        header={
                                          <h3 className="font-legal">
                                            {sectionKey}
                                          </h3>
                                        }
                                        key={sectionKey}
                                      >
                                        <ol type="1">
                                          {renderSection(
                                            howTo[sectionKey],
                                            providerData
                                          )}
                                        </ol>
                                      </AccordionTab>
                                    );
                                  })}
                                </Accordion>
                              </div>
                            </>
                          ) : (
                            <>
                              <h3>KNOW ABOUT YOUR EVENT</h3>
                              <h4>
                                Get to know what to do exactly (AI enabled).
                              </h4>

                              <Button
                                iconPos="right"
                                icon="pi pi-chevron-right"
                                className="custom-button"
                                label="Get AI enabled Process"
                                onClick={handleAIenabledService}
                                size="small"
                              />
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="event-provider-data">
                      {providerListLoading ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "200px",
                            width: "100%",
                            marginTop: "40px",
                          }}
                        >
                          <h3 style={{ margin: 0 }}>
                            <i
                              className="pi pi-spin pi-spinner-dotted"
                              style={{ fontSize: "2rem", color: "#0cc0df" }}
                            ></i>
                          </h3>
                        </div>
                      ) : providerInfo.length > 0 ? (
                        <>
                          <div className="event-service alter no-data">
                            {/* <button className="back_to_dashboard_in_provider" onClick={backtoEvents} >
                              <i className="pi pi-arrow-left"></i>
                              Back to Dashboard
                            </button> */}
                            {id === 7 ? null : <br />}
                            {id === 7 ? (
                              <div className="priest-header-divider">
                                <span className="priest-header-text">
                                  WE FOUND {providerInfo.length} {providerInfo.length === 1 ? "PRIEST" : "PRIESTS"} SERVING YOUR AREA
                                </span>
                              </div>
                            ) : (
                              <div className="servicename-wrapper">
                                <h3>{selectedlengthwithcount}</h3>
                                {id === 1 && (
                                  <span className="event-next-title">
                                    {" "}
                                    - {eventTitle}
                                  </span>
                                )}
                              </div>
                            )}
                            {id === 7 ? null : <br />}

                            {id === 7 && cancallperist && providerInfo.length > 0 && (
                              <ProviderListWithPagination
                                items={providerInfo}
                                id={7}
                                eventDetails={eventDetails}
                                cancallperist={cancallperist}
                              />
                            )}

                            {id === 8 && tentHouseFilterApplied && selectedTentHouseServiceIds.length > 0 && providerInfo.length > 0 && (
                              <ProviderListWithPagination
                                items={providerInfo}
                                id={8}
                                eventDetails={eventDetails}
                                tentHouseFilterApplied={tentHouseFilterApplied}
                                selectedTentHouseServiceIds={selectedTentHouseServiceIds}
                                serviceitemsadded={serviceitemsadded}
                              />
                            )}

                            {id === 9 && cancallcatering && providerInfo.length > 0 && (
                              <>
                                <span>Caterers and packages</span>
                                <ProviderListWithPagination
                                  items={providerInfo}
                                  id={9}
                                  eventDetails={eventDetails}
                                  cancallcatering={cancallcatering}
                                  searchText={searchText}
                                  quantity={quantity}
                                />
                              </>
                            )}

                            {id === 10 && providerInfo.length > 0 && (
                              <ProviderListWithPagination
                                items={providerInfo}
                                id={10}
                                eventDetails={eventDetails}
                                quantity={quantity}
                                selectedSpaceId={selectedSpaceId}
                                onSpaceSelected={setSelectedSpaceId}
                                renderItem={(item) => (
                                  <ProviderListingCard
                                    serviceId="10"
                                    providerid={item.id}
          appointmentProviderId={item.serviceProviderId || item.provider?.id}
                                    event={eventDetails}
                                    key={`10-${item.id}`}
                                    latitude={item.latitude}
                                    longitude={item.longitude}
                                    name={item.name}
                                    address={item.formattedAddress}
                                    distance={item.distanceInMeter}
                                    mobile={item.mobile}
                                    email={item.email}
                                    price={item.price}
                                    discount={item.discountPrice}
                                    validUpto={item.discountValidUpto}
                                    rating={item.rating || 4.5}
                                    providerFirstName={item.provider?.firstName}
                                    providerLastName={item.provider?.lastName}
                                    shortAddress={item.shortAddress || item.formattedAddress}
                                    distanceInMeter={item.distanceInMeter}
                                    primaryImage={item.primaryImage}
                                    rules={item.rules || []}
                                    sections={item.spaces || []}
                                    expectedGuestCount={quantity}
                                    selectedSpaceId={selectedSpaceId}
                                    eventStartDate={eventDetails?.Date}
                                    eventEndDate={eventDetails?.endDate}
                                    rsvpGuestCount={eventDetails?.rsvpCounts?.comingCount}
                                    onSpaceSelected={setSelectedSpaceId}
                                    onBookNow={(spaceId) => {
                                      navigate(`/venue-booking/${item.id}?eventId=${eventDetails.id}&spaceId=${spaceId}`, {
                                        state: {
                                          venueId: null,
                                          eventDetails: eventDetails,
                                        }
                                      });
                                    }}
                                  />
                                )}
                              />
                            )}
                          </div>
                        </>
                      ) : (
                        <div className="event-service alter no-data">
                          <h3 style={{ padding: "10px" }}>
                            {id === 10 ? (
                              <>
                                No venues found in your area.
                                <br />
                                <span style={{ fontSize: '14px', fontWeight: 'normal' }}>
                                  Try adjusting your search criteria or contact us for assistance.
                                </span>
                              </>
                            ) : id === 9 ? (
                              "No caterers found. Please select a meal type and cuisine."
                            ) : id === 8 ? (
                              "Choose from Tent items you want"
                            ) : id === 7 ? (
                              "No priests in your area. Try again by choosing a different Priest"
                            ) : (
                              "No providers in your area."
                            )}
                          </h3>

                          {(id === 8 || id === 9 || id === 10) && (
                            <div className="showtentpackageineventservice">
                              <span style={{ marginTop: "14px" }}>
                                {id === 9 && (
                                  <>
                                    <div className="cuisine-selection-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', marginBottom: '20px', gap: '20px' }}>
                                      {mealTypes && mealTypes.length > 0 && (
                                        <div style={{ width: '100%', maxWidth: '360px' }}>
                                          <div className="cuisine-selection-title" style={{ marginBottom: '10px', textAlign: 'center' }}>Select Meal Type:</div>
                                          <Dropdown
                                            value={selectedMeal}
                                            options={mealTypes.map(m => ({ label: m.meal_name, value: m.meal_id }))}
                                            onChange={(e) => {
                                              const mealId = e.value;
                                              setSelectedMeal(mealId);
                                              setCateringdata(prev => ({
                                                ...prev,
                                                mealIds: [mealId],
                                                typeIds: [] // Reset cuisine when meal changes
                                              }));
                                              setSelectedCuisineType(null);
                                              setcancallcatering(false);
                                            }}
                                            placeholder="Select Meal Type"
                                            filter
                                            style={{
                                              width: '100%',
                                              border: '2px solid #0cc0df',
                                              borderRadius: '25px',
                                              backgroundColor: '#ffffff',
                                              fontWeight: '600',
                                              color: '#0cc0df',
                                              boxShadow: '0 4px 10px rgba(12, 192, 223, 0.15)',
                                            }}
                                          />
                                        </div>
                                      )}

                                      {cuisineTypes && cuisineTypes.length > 0 && (
                                        <div style={{ width: '100%', maxWidth: '360px' }}>
                                          <div className="cuisine-selection-title" style={{ marginBottom: '10px', textAlign: 'center' }}>Select Cuisine Style:</div>
                                          <Dropdown
                                            value={selectedCuisineType}
                                            options={cuisineTypes.map(c => ({ label: c.name, value: c.id }))}
                                            onChange={(e) => {
                                              const cuisineId = e.value;
                                              setSelectedCuisineType(cuisineId);
                                              setCateringdata(prev => ({
                                                ...prev,
                                                typeIds: [cuisineId]
                                              }));
                                              setcancallcatering(true);
                                            }}
                                            placeholder="Select Cuisine Style"
                                            filter
                                            style={{
                                              width: '100%',
                                              border: '2px solid #0cc0df',
                                              borderRadius: '25px',
                                              backgroundColor: '#ffffff',
                                              fontWeight: '600',
                                              color: '#0cc0df',
                                              boxShadow: '0 4px 10px rgba(12, 192, 223, 0.15)',
                                            }}
                                          />
                                        </div>
                                      )}
                                    </div>

                                    <CatererOptionCard
                                      selected={true}
                                      title="Select the items of your choice"
                                      message="Please select your catering package to find the best available caterers."
                                      asset={qiCateringLogo}
                                      onClick={() => handleOpen()}
                                      available={true}
                                    />
                                  </>
                                )}
                                {id === 8 && (
                                  <StackSelectionComponent
                                    label="Select tent items"
                                    onClick={handleOpen}
                                    asset={DiningTable}
                                  />
                                )}
                                {id === 10 && (
                                  <StackSelectionComponent
                                    label="Search for venues"
                                    onClick={() => {
                                      fetchProviderList();
                                    }}
                                    asset={DiningTable}
                                  />
                                )}
                              </span>

                              {id === 8 && (
                                <>
                                  <TaperedDivider text="RECOMMENDED PACKAGES" />
                                  {tentpackages && tentpackages.length > 0 ? (
                                    <Showtentpackageforuser
                                      packages={tentpackages}
                                      eventId={eventDetails.id}
                                      eventName={eventDetails.eventTitle}
                                    />
                                  ) : (
                                    <div className="no-packages-message" style={{
                                      textAlign: 'center',
                                      padding: '20px',
                                      color: '#666',
                                      border: '1px dashed #ccc',
                                      borderRadius: '8px',
                                      margin: '20px 0'
                                    }}>
                                      <i className="pi pi-info-circle" style={{ fontSize: '24px', color: '#0cc0df' }}></i>
                                      <p style={{ marginTop: '10px' }}>No tent packages available. Please select tent items to continue.</p>
                                    </div>
                                  )}
                                </>
                              )}
                              {id === 9 && (
                                <>
                                  <TaperedDivider text="RECOMMENDED PACKAGES" />
                                  <Cateringlistofprovider
                                    longitude={eventDetails.locationLong}
                                    latitude={eventDetails.locationLat}
                                    eventTypeId={eventDetails.id}
                                    eventDetails={eventDetails}
                                  />
                                </>
                              )}
                            </div>
                          )}

                          <h4>SEND US A MESSAGE - WE WILL CONTACT YOU</h4>
                          <ButtonMailto
                            label="Send E-Mail"
                            mailto={(config.contactInfo[(process.env.REACT_APP_API_REGION || 'INDIA').toUpperCase().startsWith('IN') ? 'india' : 'usa'].email)}
                            subject={`No ${serviceName} (service provider's) available in my area`}
                            body={`Hello,\n\nNo ${serviceName} (service providers) available in my area for the ${eventTitle}.\nPlease let me know when it's available.\n\n\nThanks,\n${userDetails.firstName && capitalizeFirstLetter(userDetails.firstName)}\n${userDetails.mobileNumber && userDetails.mobileNumber}`}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {id === 1 && (
                  <Dialog
                    header={`AI enabled Service ${eventStateTitle}`}
                    visible={AIdialogVisible}
                    style={{
                      width: "calc(100% - 15px)",
                      maxWidth: "400px",
                    }}
                    modal
                    onHide={() => {
                      setAIdialogvisible(false);
                      navigate("/dashboard");
                    }}
                  >
                    <form
                      onSubmit={formik.handleSubmit}
                      style={{ width: "100%", border: 0 }}
                    >
                      <div className="event-service-head-inner">
                        <div className="event-chantgpt-fields">
                          {eventStateTitle ? (
                            <TextField
                              type="hidden"
                              name="event"
                              value={formik.values.event}
                              style={{ position: "absolute", zIndex: -1 }}
                            />
                          ) : (
                            <TextField
                              size="small"
                              name="event"
                              label="Enter Event"
                              value={formik.values.event}
                              onChange={handleFieldChange("event")}
                              variant="outlined"
                              sx={textFieldStyles}
                            />
                          )}
                          <Autocomplete
                            size="small"
                            sx={textFieldStyles}
                            options={states}
                            getOptionLabel={(option) => option.name}
                            value={
                              states.find(
                                (option) =>
                                  option.name === formik.values.Location
                              ) || null
                            }
                            onInputChange={(event, newInputValue) => {
                              formik.setFieldValue("Location", newInputValue);
                            }}
                            onChange={(event, newValue) => {
                              formik.setFieldValue(
                                "Location",
                                newValue?.name || ""
                              );
                            }}
                            filterOptions={(options, state) => {
                              return options.filter((option) =>
                                option.name
                                  .toLowerCase()
                                  .includes(state.inputValue.toLowerCase())
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Region / State"
                                variant="outlined"
                                name="Location"
                                sx={textFieldStyles}
                              />
                            )}
                            disableClearable
                            loading={states.length === 0}
                          />

                          <Autocomplete
                            size="small"
                            sx={textFieldStyles}
                            options={languages}
                            getOptionLabel={(option) => option.name}
                            value={
                              languages.find(
                                (option) =>
                                  option.name === formik.values.Language ||
                                  option.name ===
                                  states.find(
                                    (state) =>
                                      state.name === formik.values.Location
                                  )?.defaultLanguage
                              ) || null
                            }
                            onInputChange={(event, newInputValue) => {
                              formik.setFieldValue("Language", newInputValue);
                            }}
                            onChange={(event, newValue) => {
                              formik.setFieldValue(
                                "Language",
                                newValue?.name || ""
                              );
                            }}
                            filterOptions={(options, state) => {
                              return options.filter((option) =>
                                option.name
                                  .toLowerCase()
                                  .includes(state.inputValue.toLowerCase())
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Language"
                                variant="outlined"
                                name="Language"
                                sx={textFieldStyles}
                              />
                            )}
                            disableClearable
                            loading={languages.length === 0}
                          />

                          <Autocomplete
                            size="small"
                            sx={textFieldStyles}
                            options={ReligionAndCaste?.religion || []}
                            getOptionLabel={(option) => option.name}
                            value={
                              ReligionAndCaste?.religion?.find(
                                (option) =>
                                  option.name === formik.values.Religion
                              ) || null
                            }
                            onChange={(event, newValue) =>
                              handleReligionFieldChange("Religion", newValue)
                            }
                            filterOptions={(options, state) => {
                              return options.filter((option) =>
                                option.name
                                  .toLowerCase()
                                  .includes(state.inputValue.toLowerCase())
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Religion"
                                variant="outlined"
                                name="Religion"
                                sx={textFieldStyles}
                              />
                            )}
                            disableClearable
                            loading={ReligionAndCaste?.religion?.length === 0}
                          />

                          <Autocomplete
                            size="small"
                            sx={textFieldStyles}
                            options={castes || []}
                            key={`caste-${casteKey}`}
                            getOptionLabel={(option) => option.name}
                            value={
                              castes.find(
                                (option) => option.name === formik.values.Caste
                              ) || null
                            }
                            onInputChange={(event, newInputValue) => {
                              formik.setFieldValue("Caste", newInputValue);
                            }}
                            onChange={(event, newValue) =>
                              handleCasteFieldChange("Caste", newValue)
                            }
                            filterOptions={(options, state) => {
                              return options.filter((option) =>
                                option.name
                                  .toLowerCase()
                                  .includes(state.inputValue.toLowerCase())
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Caste"
                                variant="outlined"
                                name="Caste"
                                sx={textFieldStyles}
                              />
                            )}
                            disableClearable
                            loading={castes.length === 0}
                          />

                          <TextField
                            size="small"
                            variant="outlined"
                            name="SubCaste"
                            label="Select Sub Caste"
                            value={formik.values.SubCaste}
                            onChange={handleFieldChange("SubCaste")}
                            sx={textFieldStyles}
                          />
                          <TextField
                            size="small"
                            variant="outlined"
                            name="Gothram"
                            label="Enter host Gothram"
                            value={formik.values.Gothram}
                            onChange={handleFieldChange("Gothram")}
                            sx={textFieldStyles}
                          />
                          <span
                            style={{
                              fontSize: "10px",
                              color: "#737373",
                            }}
                          >
                            WE ONLY COLLECT THIS INFORMATION TO GIVE YOU
                            SUITABLE DETAILS AND FILTER SERVICES, AND NOT FOR
                            ANY OTHER REASON
                          </span>
                          <Button
                            style={{ width: "100%" }}
                            type="submit"
                            className="custom-button"
                            label="Submit"
                          />
                        </div>
                      </div>
                    </form>
                  </Dialog>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {id === 7 && cartData.preist?.[eventDetails?.id] && (
        <div className="sticky-cart-bottom-bar">
          <div className="bottom-bar-content">
            <div className="bottom-bar-left">
              <span className="selected-price">
                ₹{cartData.preist[eventDetails.id].discountprice ?? cartData.preist[eventDetails.id].price}
              </span>
              <span className="selected-count">1 priest selected</span>
            </div>
            <button className="bottom-bar-right" onClick={() => navigate("/cart")}>
              View Cart <i className="pi pi-arrow-right" style={{ fontSize: '13px', marginLeft: '6px' }}></i>
            </button>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}

export default EventServices;